import { DataGrid } from '@tableau/data-grid-1-wrapper';
import { ISiteNameWithId } from '../../../src/ts/ServerApi/types/ISiteNameWithId';
import { Messages } from '../../codegen/Localize';
import { DataGridCells } from '../../common/react/components/dataGrid/DataGridCells';
import { ReactCheckboxTristate } from '../../common/react/components/ReactCheckboxTristate';
import { SiteRolePickerMenu, DefaultDropdownMenuWidth } from '../../common/react/components/SiteRolePickerMenu';
import { AngularContext } from '../../ts/factories/AngularContextFactory';

export module SiteMembershipGridColumns {

  export function columns(
    dropdownProps: (site: ISiteNameWithId) => SiteRolePickerMenu.Props,
    checkboxProps: (site: ISiteNameWithId) => ReactCheckboxTristate.Props,
    angularContext: AngularContext
  ): DataGrid.Column[] {

    const columns: DataGrid.Column[] = [
      {
        name: 'select-site-col',
        dataKey: '0',
        headerText: '',
        cellFormatter: DataGridCells.SiteGridCheckboxCell(checkboxProps),
        preferredWidth: 40,
        resizable: false,
        sortable: false,
      },
      {
        name: 'site-name-col',
        dataKey: '1',
        headerText: Messages.site(),
        cellFormatter: DataGridCells.PlainTextCell('name'),
        preferredWidth: 160,
        resizable: false,
        sortable: false
      },
      {
        name: 'site-select-col',
        dataKey: '2',
        headerText: Messages.siteRole(),
        headerFormatter:  DataGridCells.SiteRolePopoverCell(angularContext),
        cellFormatter: DataGridCells.SiteGridDropdownCell(dropdownProps, checkboxProps),
        preferredWidth: DefaultDropdownMenuWidth + 24, // adding 24 to account for padding on data grid defined in reactDataGrid.styl,
        resizable: false,
        sortable: false
      }];
    return columns;
  }
}
